import React, { Component } from "react";
import ReactDOM from "react-dom";
import Button from "@mui/material/Button";
import Headers from "../Layouts/Headers";
import { GynecologySidebar } from "../Layouts/GynecologySidebar";
import Footers from "../Layouts/Footers";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";

export class GynecologyDashboard extends Component {
  constructor(props) {
    super(props);

   

    ////
    const url = "";

    this.state = {
      paymentsstatus: "pending",
    };
  }

  componentDidMount() {
    console.log(localStorage.getItem("currentVisitId"));
    //     const article = { title: 'React POST Request Example' };
    // axios.post('https://reqres.in/api/articles', article)
    // .then(response => this.setState({ articleId: response.data.id }));
  }

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    return (
      <div>
        <Headers></Headers>
        <section className="service-area" id="services more-top-padding">
          <div className="container more-top-padding">
            <div className="row">
              <div className="col-xs-12"></div>
            </div>
            <br />
            <br />
            <div
              className="row wow center bounceInUp"
              data-wow-duration="1.2s"
              data-wow-delay="1.2s"
            >
              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4  center col-xs-12">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-pills"></i>
									</div>
									<h3><a href="/gynecology/antenatal/history"> Antenatal History </a> </h3>
									<p>
									</p>
								</div> 
                                
                                
                                
                                <Route exact path='/gynecology/dashboard' component={GynecologyDashboard} />
				<Route exact path='/gynecology/antenatal/history' component={GAntenatalHistory} />
				<Route exact path='' component={GDiagnosisStudy} />
				<Route exact path='' component={GMenstrualHistory} />
				<Route exact path='' component={GObSound}/>
				<Route exact path='' component={GPhysicalExamination} />
				<Route exact path='' component={GPrePlanAnalysis} />
				<Route exact path='' component={GPreviousObstetricsHistory} />
				<Route exact path='' component={GPreviousPregnantComplication} />
				<Route exact path='/gynecology/search/in/module' component={GSearchInModule} />
				<Route exact path='' component={GUtilizationOfDrugs} />
                                
                                
                                
                                
                                */}
                <a
                  className="navbar-brand"
                  href="/gynecology/antenatal/history"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Antenatal History
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        >
                          Here, Enter all the required <br />
                          details for a new Patient
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>

              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12 center">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-ambulance"></i>
									</div>
									<h3><a href="/diagnosis/study">Diagnosis and Plan</a></h3>
									<p>
										Efficiency, speed and professionalism <br />is key with <br />our ambulance service
									</p>
								</div> */}
                <a className="navbar-brand" href="/gynecology/ob/sound">
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-table icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Obstetrics UltraSound
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12 center">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-ambulance"></i>
									</div>
									<h3><a href="/diagnosis/study">Diagnosis and Plan</a></h3>
									<p>
										Efficiency, speed and professionalism <br />is key with <br />our ambulance service
									</p>
								</div> */}
                <a className="navbar-brand" href="/gynecology/diagnosis/study">
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Diagnosis and Plan
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>

              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12  center">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-tint"></i>
									</div>
									<h3><a href="/menstrual/history">Menstrual History</a></h3>
									<p>
										Our team caters for your diagnosis <br />and treatment wih effectiveness<br />
										and outmost care.
									</p>
								</div> */}
                <a
                  className="navbar-brand"
                  href="/gynecology/menstrual/history"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Menstrual History
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>

              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12  center">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-flask"></i>
									</div>
									<h3><a href="/physical/examination">Physical Examination</a></h3>
									<p>
										Pathology Laboratory performs tests on a Routine Basis and STAT according to the needs of the patients.
									</p>
								</div> */}
                <a
                  className="navbar-brand"
                  href="/gynecology/physical/examination"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Physical Examination
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>

              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12  center">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="/preplan/analysis">Preplan Analysis Executed</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
                <a className="navbar-brand" href="/gynecology/preplan/analysis">
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Preplan Analysis Executed
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>
              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12  center">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="/previous/obstetrics/history">Previous Obstetrics History</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
                <a
                  className="navbar-brand"
                  href="/gynecology/previous/obstetricsHistory"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Previous Obstetrics History
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>

              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12  center">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="/previous/pregnancy/complication">Previous Pregnant Complication</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
                <a
                  className="navbar-brand"
                  href="/gynecology/previous/pregnant/complication"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Previous Pregnancy <br />
                          Complication
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>

              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12  center">
                {/* <div className="service-wrap text-center">
									<div className="service-icon">
										<i className="fa fa-medkit"></i>
									</div>
									<h3><a href="">Utilization Of Drugs</a></h3>
									<p>
										We pride ourselves <br /> in delivering bundles of joy to the world, and ensuring your family stays strong even upto postnatal care.
									</p>
								</div> */}
                <a
                  className="navbar-brand"
                  href="/gynecology/utilization/of/drugs"
                >
                  <Card
                    className="innerdashboardcards center"
                    variant="outlined"
                  >
                    <CardActionArea>
                      <div className="full-width center pt-4">
                        <CardMedia
                          className="fa fa-plus-square icon-medium color-blue"
                          component="icon"
                          alt="Triage"
                        />
                      </div>
                      <CardContent>
                        <Typography
                          align="center"
                          gutterBottom
                          variant="h6"
                          component="div"
                          className="color-blue"
                        >
                          Utilization Of Drugs
                        </Typography>
                        <Typography
                          gutterBottom
                          component="div"
                          variant="p"
                          align="center"
                          paragraph="true"
                          className="innerdashcardsp"
                        ></Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </a>
              </div>

              <div className="col-md-6 col-sm-12 col-lg-4 mb-4  mb-4   col-xs-12  center"></div>
            </div>
          </div>
          <a className="btn btn-primary sendToModule">Send to Module</a>
        </section>
        <div className="modal module_list" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title PatientName"></h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="full-width">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-row pt-4">
                      <div className="col-md-4 p-2">
                        <div className="py-1">
                          <h6
                            className="text-capitalize"
                            style={fontFamilyNunito}
                          >
                            Choose Module
                          </h6>
                          <select
                            onChange={this.handleChange}
                            value={module}
                            name="module"
                            className="form-control selectModule"
                          >
                            <optgroup label="Attended Antenatal Care">
                              <option selected disabled></option>
                              <option value="triage">Triage</option>
                              <option value="gynecology">
                                Gynecology Ward II
                              </option>
                              <option value="labour">Labour </option>
                            </optgroup>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                      <div className="col col-6">
                        <button
                          className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                          type="submit"
                          style={floatLeft}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div className="modal-footer">
                <p
                  className="alert alert-success sendModuleSuccess"
                  style={displayHidden}
                >
                  Patient Sent Successfully
                </p>
                {/* <button type="button" className="btn btn-primary sendToModule" id="">Send To Module</button> */}
                {/* <button type="button" className="btn btn-secondary" data-dismiss="modal">Close</button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GynecologyDashboard;
